import { useState } from 'react';
import { resources } from '../../../../../../assets/data/resourceData';
import { ResourceCard } from './ResourceCard';
import TutorialsList from './components/TutorialsList';
import TermsAndConditions from '../../../settings/TermAndConditions';
import PrivacyPolicy from '../../../settings/PrivacyPolicy';
import DashboardBlogViewer from './DashboardBlogViewer';

const ResourcesContent = () => {
  const [showTutorials, setShowTutorials] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showBlogs, setShowBlogs] = useState(false);

  if (showTutorials) {
    return (
      <div>
        <button
          onClick={() => setShowTutorials(false)}
          className="mb-6 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors inline-flex items-center gap-2"
        >
          ← Back to Resources
        </button>
        <TutorialsList />
      </div>
    );
  }

  if (showTerms) {
    return (
      <div>
        <button
          onClick={() => setShowTerms(false)}
          className="mb-6 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors inline-flex items-center gap-2"
        >
          ← Back to Resources
        </button>
        <TermsAndConditions />
      </div>
    );
  }

  if (showPrivacy) {
    return (
      <div>
        <button
          onClick={() => setShowPrivacy(false)}
          className="mb-6 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors inline-flex items-center gap-2"
        >
          ← Back to Resources
        </button>
        <PrivacyPolicy />
      </div>
    );
  }

  if (showBlogs) {
    return (
      <div>
        <button
          onClick={() => setShowBlogs(false)}
          className="mb-6 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors inline-flex items-center gap-2"
        >
          ← Back to Resources
        </button>
        <DashboardBlogViewer onClose={() => setShowBlogs(false)} />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4">
      <h1 className="text-xl md:text-2xl font-bold text-center mb-4 md:mb-6">
        Help & Resources
      </h1>
      <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
        Find guides, tutorials, and answers to your questions. Whether you're just getting started or want to master every feature, our resource center is here to help.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {resources.map((res, idx) => {
          // Override Video Tutorials card to show internal tutorial list
          if (res.title === 'Video Tutorials') {
            return (
              <div
                key={idx}
                onClick={() => setShowTutorials(true)}
                className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center hover:shadow-xl transition group border border-gray-100 cursor-pointer"
              >
                <div className="mb-4 text-4xl text-btn-primary">{res.icon}</div>
                <h2 className="font-bold text-lg text-center mb-2 text-btn-primary">{res.title}</h2>
                <p className="text-gray-600 text-center text-sm mb-4">{res.description}</p>
                <button className="mt-auto inline-block px-4 py-2 rounded-full bg-btn-secondary text-btn-primary font-semibold hover:bg-btn-secondary-hover transition">
                  Watch Now
                </button>
              </div>
            );
          }
          
          // Override Blog & Updates to open inline viewer
          if (res.title === 'Blog & Updates') {
            return (
              <div
                key={idx}
                onClick={() => setShowBlogs(true)}
                className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center hover:shadow-xl transition group border border-gray-100 cursor-pointer"
              >
                <div className="mb-4 text-4xl text-btn-primary">{res.icon}</div>
                <h2 className="font-bold text-lg text-center mb-2 text-btn-primary">{res.title}</h2>
                <p className="text-gray-600 text-center text-sm mb-4">{res.description}</p>
                <button className="mt-auto inline-block px-4 py-2 rounded-full bg-btn-secondary text-btn-primary font-semibold hover:bg-btn-secondary-hover transition">
                  View
                </button>
              </div>
            );
          }
          // Override Terms & Conditions card
          if (res.internal === 'terms') {
            return (
              <div
                key={idx}
                onClick={() => setShowTerms(true)}
                className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center hover:shadow-xl transition group border border-gray-100 cursor-pointer"
              >
                <div className="mb-4 text-4xl text-btn-primary">{res.icon}</div>
                <h2 className="font-bold text-lg text-center mb-2 text-btn-primary">{res.title}</h2>
                <p className="text-gray-600 text-center text-sm mb-4">{res.description}</p>
                <button className="mt-auto inline-block px-4 py-2 rounded-full bg-btn-secondary text-btn-primary font-semibold hover:bg-btn-secondary-hover transition">
                  Read More
                </button>
              </div>
            );
          }
          // Override Privacy Policy card
          if (res.internal === 'privacy') {
            return (
              <div
                key={idx}
                onClick={() => setShowPrivacy(true)}
                className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center hover:shadow-xl transition group border border-gray-100 cursor-pointer"
              >
                <div className="mb-4 text-4xl text-btn-primary">{res.icon}</div>
                <h2 className="font-bold text-lg text-center mb-2 text-btn-primary">{res.title}</h2>
                <p className="text-gray-600 text-center text-sm mb-4">{res.description}</p>
                <button className="mt-auto inline-block px-4 py-2 rounded-full bg-btn-secondary text-btn-primary font-semibold hover:bg-btn-secondary-hover transition">
                  Read More
                </button>
              </div>
            );
          }
          return <ResourceCard key={idx} {...res} />;
        })}
      </div>
    </div>
  );
};

export default ResourcesContent;